import $ from '../vendor/jquery';

$('.popup-link').magnificPopup({
  type: 'image',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false,
});

$('.video-list a').magnificPopup({
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false,
  iframe: {
    patterns: {
      youtube: {
        index: 'youtube.com',
        id: 'v=',
        src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
      }
    }
  }
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/popup.js